module.exports = __webpack_public_path__ + "static/images/group-bb.55eab3d.png";